/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 23-08-2020.
 */
import React from 'react'
import { DELIVERY_TIME } from './constant'
import FadeUp from './animation/FadeUp'

const HowTo = () => {
  const isMobile = false // useMediaQuery({ maxWidth: 767 })

  return (
    <div className="container-fluid bg-white">
      <div className="container py-6">
        <FadeUp className="row" style={{}}>
          <div className="col-12 mt-6">
            <h3 className="fw-bold my-3 text-center">Sådan gør du </h3>
          </div>

          <div className="col-12 col-md-6 d-flex mx-auto text-center">
            <p>
              Vi anbefaler, at du måler op og tager imod den kyndige vejledning, som IKEAs køkkenafdeling tilbyder. Så
              uploader du bare din tegning og vælger dit design.
            </p>
          </div>
        </FadeUp>
        <FadeUp className="row mb-7 mt-6 h-100">
          <div
            className="col-12 col-md-4  mb-5 px-4 px-md-6"
            style={{ borderRight: isMobile ? '' : '1px solid #E3E3E3' }}
          >
            <h1 className="mb-4 text-center">01</h1>
            <h5 className="text-md-left text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
              Planlæg og mål
            </h5>
            <p className="text-muted text-center text-md-start">
              Du begynder med at måle dit køkken og lave en plan ved hjælp af{' '}
              <a href="https://www.ikea.com/dk/da/planners/kitchen-planner/">Ikea's online værktøjer</a>
            </p>
            <p className="mt-3"> Husk at sætte fronter på dine tegninger, også selvom du ikke køber dem hos IKEA.</p>
          </div>
          <div
            className="col-12 col-md-4 mb-5 px-4 px-md-6"
            style={{ borderRight: isMobile ? '' : '1px solid #E3E3E3' }}
          >
            <h1 className="mb-4 text-center">02</h1>
            <h5 className="text-md-left text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
              Vælg dit Hackk-design
            </h5>
            <p className="text-muted text-center text-md-start">
              Når din IKEA-bestilling er i hus, begynder det sjove – for nu skal du vælge dit design. Find fronterne til
              dit drømmekøkken, og send tegningen til os, så klarer vi resten.
            </p>
          </div>
          <div className="col-12 col-md-4 mb-5 px-4 px-md-6">
            <h1 className="mb-4 text-center">03</h1>
            <h5 className="text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
              Leveret inden for {DELIVERY_TIME}
            </h5>
            <p className="text-muted text-center text-md-start">
              Din bestilling bliver leveret til gadedøren og kan straks installeres. Ligesom resten af dit IKEA-køkken
              er det let at finde ud af. Og vi står altid klar til at hjælpe.
            </p>
          </div>

          {/*<div className="col-12 col-md-4 h-100" style={{ background: 'red' }}>
            <div className="h-100" style={{ borderRight: isMobile ? '' : '1px solid #E3E3E3' }}>
              <div className="w-100 px-5 px-md-4 py-5" style={{}}>
                <h1 className="mb-4 text-center">01</h1>
                <h5 className="text-md-left text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
                  Planlæg og mål
                </h5>
                <p className="text-muted text-center text-md-left">
                  Mål op og planlæg med IKEAs smarte tegneprogram online. Husk at sætte fronter på dine tegninger, også
                  selvom du ikke køber dem hos IKEA.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 h-100" style={{ background: 'red' }}>
            <div className="h-100" style={{ borderRight: isMobile ? '' : '1px solid #C1C1C1' }}>
              <div className="w-100 px-5 px-md-4 py-5" style={{ background: isMobile ? '#e9e9e9' : '' }}>
                <h1 className="mb-4 text-center  ">02</h1>

                <h5 className="text-md-left text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
                  Vælg dit Hackk-design
                </h5>
                <p className="text-muted text-center text-md-left">
                  Når din IKEA-bestilling er i hus, begynder det sjove – for nu skal du vælge dit design. Find fronterne
                  til dit drømmekøkken, og send tegningen til os, så klarer vi resten.
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4  h-100" style={{ background: 'red' }}>
            <div style={{}}>
              <div className="w-100 px-5 px-md-4 py-5" style={{}}>
                <h1 className="mb-4 text-center">03</h1>
                <h5 className="text-md-left text-center fw-bold mb-3" style={{ fontSize: '1.4rem' }}>
                  Leveret inden for {DELIVERY_TIME} uger
                </h5>

                <p className="text-muted text-center text-md-left">
                  Din bestilling bliver leveret til gadedøren og kan straks installeres. Ligesom resten af dit
                  IKEA-køkken er det let at finde ud af. Og vi står altid klar til at hjælpe.
                </p>
              </div>
            </div>
          </div>*/}
        </FadeUp>
      </div>
    </div>
  )
}
export default HowTo
